









import Vue from 'vue'
import RouteAssistant from '@/helpers/route-assistant'
import ColorAssistant from '@/helpers/color-assistant'

export default Vue.extend({
  name: 'NewConversationButton',

  props: {
    mailboxId: {
      type: Number,
      required: true,
    },
    mailboxName: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: 'large',
    },
  },
  data() {
    return { ColorAssistant, RouteAssistant }
  },
  methods: {
    handleClick() {
      RouteAssistant.goToCreateConversation(
        this.$router,
        this.$route.params.accountId,
        this.mailboxId,
        this.mailboxName,
      )
    },
  },
})
